<template>
  <div id="shiplocation">
    <div class="ship">
      <el-carousel indicator-position="outside">
        <el-carousel-item v-for="(item,index) in 2" :key="index">
          <ul class="shiplist">
            <li v-for="(item,index) in vrtj[index]" :key="index" @click="urls(item.vrlink)">
              <div class="img_left_top">
                <img v-lazy="item.logo" :alt="item.title">
              </div>
              <div class="_left_text">
                {{item.title}}
              </div>
            </li>
          </ul>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="location">
      <ul class="locationlist">
        <li style="margin-left: 1.9%;" @click="gotoVrshows">
          <div class="icon_titl">
            <img src="../../src/imges/top/zt.png" alt="企业VR">
          </div>
          <div class="ico_text">
            企业VR
          </div>
        </li>
        <li @click="cnmlgb">
          <div class="icon_titl">
            <img src="../../src/imges/top/vrdt.png" alt="船海地图">
          </div>
          <div class="ico_text">
            船海地图
          </div>
        </li>
        <li @click="gb_sqzz">
          <div class="icon_titl">
            <img src="../../src/imges/top/sqps.png" alt="企业VR申请拍摄">
          </div>
          <div class="ico_text">
            企业VR申请拍摄
          </div>
        </li>
      </ul>
    </div>


    <div class="popContainer" v-if="isShowSQ">
      <!-- 制作 -->
      <div class="sq_ewm">
        <div class="sq_ewm_title">企业VR申请拍摄</div>
        <div class="gb_sqewm" @click="gb_sqzz">
          ×
        </div>
        <div class="from_sq">
          <el-form :label-position="labelPosition" label-width="120px" :model="formLabelAlign">
            <el-form-item label="单位名称" class="dwmc_warp">
              <el-input v-model="formLabelAlign.dbname"></el-input>
            </el-form-item>
            <el-form-item label="联系人" class="lxr_warp">
              <el-input v-model="formLabelAlign.name"></el-input>
            </el-form-item>
            <el-form-item label="职务" class="zw_warp">
              <el-input v-model="formLabelAlign.zw"></el-input>
            </el-form-item>
            <el-form-item label="手机" class="zw_warp">
              <el-input v-model="formLabelAlign.phone"></el-input>
            </el-form-item>
            <el-form-item label="电话" class="zw_warp">
              <el-input v-model="formLabelAlign.telephone"></el-input>
            </el-form-item>
            <el-form-item label="邮箱" class="zw_warp">
              <el-input v-model="formLabelAlign.email"></el-input>
            </el-form-item>
            <el-form-item label="展示选项" class="dwmc_warp">
              <el-checkbox-group v-model="formLabelAlign.zhanshi">
                <el-checkbox label="VR全景展示"></el-checkbox>
                <el-checkbox label="船海地图"></el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label="添加链接" class="dwmc_warp">
              <el-input v-model="formLabelAlign.link"></el-input>
            </el-form-item>
            <el-form-item style="margin-top:5px;">
              <el-button style="width:180px;font-size:1.1rem;background:red;border:none;" type="primary"
                         @click="submitVRsq()">立即申请</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from "@/utils/http";
export default {
  data() {
    return {
      isShowSQ: false,
      formLabelAlign: {
        uid: 0,
        unitName: '', //单位名称
        contacts: '', //联系人
        userPost: '', //职务
        phone: '', //手机号
        telephone: '', //电话
        email: '', //邮箱
        zhanshi: [],
        linkAddress: '', //添加链接
        VRZT: true, //vr展厅
        VRDT: true //vr地图
      },
      labelPosition: 'left',
      vrtj: ''
    }
  },
  mounted() {
    this.mbmb()
  },
  methods: {
    cnmlgb() {
      document.querySelector("#hhdt").scrollIntoView(true);
    },
    urls(id) {
      window.open(id)
    },
    gotoVrshows() {
      this.$router.replace('/Vrshow')
    },
    gb_sqzz() {
      this.isShowSQ = !this.isShowSQ
    },
    async mbmb() {
      let res = await http.get('api/qydb/tuijian')
      let XpList = res.data.data
      let newArr = [
        [],
        [],
      ]
      XpList.forEach((item, index) => {
        if (index < 3) {
          newArr[0].push(item)
        } else if (index >= 3 && index < 6) {
          newArr[1].push(item)
        } else if (index >= 6 && index < 9) {
          newArr[2].push(item)
        }
      })
      this.vrtj = newArr
    },
    async submitVRsq() {

      if (this.formLabelAlign.email == '') {
        this.$message.error("邮件地址不能为空");
        return;
      }

      if (
          !/^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((.[a-zA-Z0-9_-]{2,3}){1,2})$/.test(
              this.formLabelAlign.email
          )
      ) {
        this.$message.error("邮箱格式不正确");
        return;
      }


      const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
      if (this.formLabelAlign.phone == '' || this.formLabelAlign.phone.length <= 10 || !reg.test(this.formLabelAlign.phone)) {
        this.$message({
          message: "请填写正确的手机号！！",
        });
        return;
      }


      let that = this;
      const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
      if (!loginInfo) {
        that.$alert('请登录', '提示', {
          confirmButtonText: '确定',
        });
        this.$router.replace('/login')
        return false;
      }
      this.formLabelAlign.uid = String(loginInfo.id)
      this.$axios({
        url: 'https://admin.shipoe360.com/api/picture/vrzs',
        method: "post",
        params: this.formLabelAlign
      }).then(res => {
        that.$alert(res.data.msg, '提示', {
          confirmButtonText: '确定',
        });
        this.isShowSQ = false
      })
    }
  }
}
</script>

<style scoped>
#shiplocation .ship {
  width: 55%;
  float: left;
  height: 170px;
  overflow: hidden;
}

.ship /deep/ .el-carousel__container {
  height: 150px;
}


#shiplocation .location {
  width: 45%;
  float: right;
  height: 150px;
}

.shiplist {
  width: 100%;
  height: 150px;
  margin: 0px;
  padding: 0px;
}

.shiplist>li {
  list-style: none;
  width: 30%;
  height: 150px;
  float: left;
  margin-left: 3%;
}

.shiplist>li:hover {
  cursor: pointer;
}

/* .shiplist>li:first-child{
  margin-left: 0%;
} */

.locationlist {
  width: 100%;
  height: 150px;
  margin: 0px;
  padding: 0px;
}

.locationlist>li:hover {
  cursor: pointer;
}

.locationlist>li {
  list-style: none;
  position: relative;
  width: 32%;
  height: 150px;
  float: left;
  margin-left: 1%;
  background-color: rgb(247, 240, 239);
  border-radius: 15px;
  display: flex;
  justify-content: space-around;
}

.locationlist>li>.icon_titl {
  position: absolute;
  top: 25px;
  left: calc((100% - 60px) / 2);
  width: 60px;
  height: 60px;
}

.locationlist>li>.icon_titl>img {
  width: 100%;
  height: 100%;
}

.locationlist>li>.ico_text {
  margin-top: 100px;
  width: 100%;
  text-align: center;
  font-size: 14px;
  font-weight: 600;
}

.popContainer {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  background: rgba(0, 0, 0, 0.6);
}

.sq_ewm {
  position: absolute;
  top: 50%;
  left: 50%;
  margin-left: -250px;
  margin-top: -300px;
  width: 500px;
  background-color: #fff;
  border-radius: 10px;
  overflow: hidden;
  z-index: 9999;
}


.sq_ewm .sq_ewm_title {
  height: 60px;
  background-color: #e90e0e;
  color: #fff;
  text-align: center;
  line-height: 60px;
  font-size: 20px;
  letter-spacing: 6px;
}

.sq_ewm .gb_sqewm {
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
  width: 20px;
  height: 20px;
}


.sq_ewm .from_sq {
  width: 80%;
  margin: 10px auto;
}

/deep/ .el-form-item__label {
  font-size: 16px;
}

.from_sq /deep/ .el-form-item {
  margin-bottom: 5px;
}

/deep/ .dwmc_warp label {
  letter-spacing: 4px;
}

/deep/ .zw_warp {
  letter-spacing: 30px;
}

/deep/ .lxr_warp {
  letter-spacing: 14px;
}

/deep/ .search_sty_input input {
  border: #ca151e 2px solid;
  height: 40px;
  line-height: 40px;
  border-right: none;
}


.img_left_top {
  height: 120px;
  width: 100%;
  overflow: hidden;
}

.img_left_top>img {
  width: 100%;
  display: table-cell;
  text-align: center;
  vertical-align: middle;
  height: 100%;
}

._left_text {
  line-height: 25px;
  text-align: center;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 14px;
  position: absolute;
  background: #999999;
  width: 30%;
  color: #fff;
  height: 25px;
  font-size: 12px;
  border-radius: 0px 0px 8px 8px;
}
</style>
